const $ = jQuery.noConflict();

'use strict';

const FocusInput = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.formMove();
		this.formAutofill();
		$('.wpcf7-tel').on('input', function() {
			const nonNumReg = /[^0-9]/g;
			$(this).val($(this).val().replace(nonNumReg, ''));
		});
		$('.wpcf7-tel').attr({maxLength: 13});
		const el = document.querySelector('.wpcf7-tel');
		if (el){
			el.addEventListener('keyup', (e) => {
				const val = e.target.value;
				e.target.value = val
					.replace(/\D/g, '')
					.replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/g, function(txt, f, s, t) {
						if (t) {
							return `(${f}) ${s}-${t}`;
						} else if (s) {
							return `(${f}) ${s}`;
						} else if (f) {
							return `(${f})`;
						}
					});
			});
		}
		const inputFocus = $('.input-text');
		inputFocus.blur();
	},

	/** @description */

	formMove: function() {
		$('input').on('focus', function() {
			if (!$(this).val()) {
				$(this).parent().siblings('label').addClass('move');
			}
		});
		$('input').on('blur', function() {
			if (!$(this).val()) {
				$(this).parent().siblings('label').removeClass('move');
			}
		});
		$('input').on('change', function() {
			if (!$(this).val()) {
				$(this).parent().siblings('label').removeClass('move');
			} else {
				$(this).parent().siblings('label').addClass('move');
			}
		});

		$('form').find('input').each(() => {
			$('#your-email').on('change', function() {
				if (!$(this).val()) {
					$(this).parent().siblings('label').removeClass('move');
				} else {
					$(this).parent().siblings('label').addClass('move');
				}
			});
		});
		$('form').find('input').each(() => {
			$('.js-location').on('change', function() {
				if (!$(this).val()) {
					$(this).parent().siblings('label').removeClass('move');
				} else {
					$(this).parent().siblings('label').addClass('move');
				}
			});
			if (!$('.js-location').val()) {
				$(this).parent().siblings('label').removeClass('move');
			} else {
				$(this).parent().siblings('label').addClass('move');
			}
			if (!$('.js-location-search-form').val()) {
				$(this).parent().siblings('label').removeClass('move');
			} else {
				$(this).parent().siblings('label').addClass('move');
			}
		});
	},
	formAutofill: function() {
		$('input.wpcf7-form-control, textarea.wpcf7-form-control').attr('autocomplete', 'negative');
	},
};

export default FocusInput;